import {
  AHIcon,
  AHIconType,
  AHText,
  Box,
  ColorType,
  TouchableBox,
  useTheme,
} from "arkh";
import Color from "color";
import { useMemo, useState } from "react";
import { useFragment, graphql } from "react-relay";

import { TeamAppInfoButton_appInfo$key } from "./__generated__/TeamAppInfoButton_appInfo.graphql";
let _hidden = false;
export function TeamUpdateInfoButton(props: {
  onPress: (linkURL: string) => void;
  appInfo: TeamAppInfoButton_appInfo$key;
}) {
  const [hidden, setHidden] = useState(_hidden);
  const appInfo = useFragment(
    graphql`
      fragment TeamAppInfoButton_appInfo on AppInfo {
        title
        description
        linkURL
        type
      }
    `,
    props.appInfo
  );
  const hide = () => {
    _hidden = true;
    setHidden(true);
  };
  const theme = useTheme();
  const { color, icon } = useMemo((): {
    color: ColorType;
    icon: AHIconType;
  } => {
    switch (appInfo.type) {
      case "UPDATE":
        return {
          color: "surface-cta",
          icon: "storesprint-update",
        };
      case "INFO":
        return {
          color: "surface-cta",
          icon: "info",
        };
      case "WARNING":
        return {
          color: "negative",
          icon: "issue",
        };
      default:
        return {
          color: "surface-cta",
          icon: "info",
        };
    }
  }, [appInfo.type]);

  const tintColor = useMemo(() => {
    return Color(theme[color]).mix(Color("#FFFFFF"), 0.9).string();
  }, [color, theme]);

  if (hidden || !appInfo) {
    return null;
  }

  return (
    <Box spaceHorizontal="medium" spaceTop="medium">
      <TouchableBox
        onPress={() => props.onPress(appInfo.linkURL)}
        space="medium"
        cornerRadius="medium"
        style={{ backgroundColor: tintColor }}
      >
        <Box
          style={{
            flexDirection: "row",
            alignItems: "flex-end",
            justifyContent: "space-between",
          }}
          spaceBottom="small"
        >
          <Box
            style={{
              flexDirection: "row",
              alignItems: "flex-end",
              justifyContent: "space-between",
            }}
          >
            <AHIcon
              spaceRight="xsmall"
              color={color}
              size="small"
              type={icon}
            />
            <AHText spaceLeft="xsmall" color="text-primary" type="subtitle">
              {appInfo.title}
            </AHText>
          </Box>

          <TouchableBox
            spaceLeft="medium"
            hitSlop={{
              left: 10,
              top: 10,
              bottom: 10,
              right: 10,
            }}
            onPress={hide}
          >
            <AHIcon type="clear" color="text-secondary" />
          </TouchableBox>
        </Box>
        {appInfo.description ? (
          <AHText color="text-secondary">{appInfo.description}</AHText>
        ) : null}
      </TouchableBox>
    </Box>
  );
}
